export const LOAD_DATA = 'LOAD_DATA'
export const ADD_TO_NOTIFICATION = 'ADD_TO_NOTIFICATION'
export const SET_DATA = 'SET_DATA'
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT'
export const REMOVE_DATA = 'REMOVE_DATA'
export const REMOVE_All_DATA = 'REMOVE_All_DATA'


